import consola from 'consola'
/**
 * Плагин для загрузки инструментов отладки авторизации
 * 
 * Добавляет в window:
 * - window.$authCheck() - полная диагностика системы
 * - window.$debugTokens() - статус токенов
 * - window.$logoutHistory - история разлогиниваний
 */

export default defineNuxtPlugin(async () => {
  if (!process.client) return
  
  try {
    // Загружаем утилиты отладки
    await import('~/utils/diagnostics/authSystemCheck')
    await import('~/utils/debugTokenStatus')
    
    consola.log('🛠️ [DebugTools] Инструменты отладки загружены:')
    consola.log('   • window.$authCheck() - полная диагностика')
    consola.log('   • window.$debugTokens() - статус токенов')
    consola.log('   • window.$logoutHistory.print() - история разлогиниваний')
    
  } catch (error) {
    consola.warn('[DebugTools] Не удалось загрузить инструменты отладки:', error)
  }
})

